interface EyebrowProps {
  children: string;
  tone?: 'light' | 'dark';
  className?: string;
}

export default function Eyebrow({ children, tone = 'light', className = '' }: EyebrowProps) {
  return (
    <p
      className={`font-label text-[12px] md:text-[13px] font-medium uppercase tracking-[0.18em] ${
        tone === 'dark' ? 'text-accent-400' : 'text-accent-600'
      } ${className}`}
    >
      {children}
    </p>
  );
}